import React from 'react';
import PT from 'prop-types';
import { MDCCheckbox } from '@material/checkbox';

export class Checkbox extends React.Component {
    constructor(props) {
        super(props);
        this.checkboxRef = React.createRef();
    }

    componentDidMount() {
        this.checkbox = new MDCCheckbox(this.checkboxRef.current);
    }

    componentDidUpdate(prevProps) {
        if (this.props.checked != prevProps.checked)
            this.checkbox.checked = this.props.checked;

        console.log(this.checkbox.checked);
    }

    render() {
        return (
            <div className="mdc-form-field">
                <div className="rese-checkbox mdc-checkbox" ref={this.checkboxRef}>
                    <input 
                        type="checkbox"
                        id={this.props.id}
                        className="mdc-checkbox__native-control"
                        onClick={this.props.onCheck}
                        defaultChecked={this.props.checked} />
                    <div className="mdc-checkbox__background">
                        <svg className="mdc-checkbox__checkmark"
                            viewBox="0 0 24 24">
                            <path className="mdc-checkbox__checkmark-path"
                                    fill="none"
                                    d="M1.73,12.91 8.1,19.28 22.79,4.59">    
                            </path>
                        </svg>
                        <div className="mdc-checkbox__mixedmark"></div>
                    </div>
                    <div className="mdc-checkbox__ripple"></div>
                </div>
                <label htmlFor={this.props.id}>{this.props.label}</label>
            </div>
        );
    }
}
Checkbox.propTypes = {
    label: PT.string.isRequired,
    onCheck: PT.func.isRequired,
    id: PT.string.isRequired,
    checked: PT.bool
};
Checkbox.defaultProps = {
    checked: false
};